// Accordion
import 'regenerator-runtime';
import { API_KEY } from '../scripts/setup';

const accordion = document.querySelector('.accordion');
const btnThird = document.querySelector('.third');

accordion.addEventListener('click', (e) => {
  if (e.target.classList.contains('content')) return;
  if (e.target.classList.contains('btn')) return;
  if (e.target.classList.contains('p')) return;

  const panel = e.target.closest('.panel');

  const content = panel.nextElementSibling;

  content.classList.toggle('active');
});

const popup = document.querySelector('.popup');

const setCountry = async () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      async (data) => {
        const lat = data.coords.latitude;
        const log = data.coords.longitude;
        await fetch(
          `https://us1.locationiq.com/v1/reverse.php?key=${API_KEY}&lat=${lat}&lon=${log}&accept-language=en&format=json`
        )
          .then((res) => res.json())
          .then((data) => {
            sessionStorage.setItem('code', data.address['country_code']);
            sessionStorage.setItem('country', data.address.country);
          });
      },
      (data) => {
        popup.classList.remove('hidden');
        btnThird.style.pointerEvents = 'none';
        popup.textContent =
          'You will not be able to instantly get data about your country. If you want to use this service give us perrmission, and reload the page. We are NOT storing this data anywhere.';
        setTimeout(() => {
          popup.classList.add('hidden');
        }, 5000);
      }
    );
  } else {
    alert('Something went wrong.');
  }
};

setCountry();

const burger = document.querySelector('.burger');
const ul = document.querySelector('.header__nav ul');

burger.addEventListener('click', () => {
  ul.classList.toggle('active');
});

console.log(burger, ul);
